"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const useDelay_1 = __importDefault(require("../hooks/useDelay"));
/**
 * LoadingBar is a wrapper over the MUI LinearProgress.
 *
 * This component avoids "Flash of Loading Bar" for quickly loding resources by waiting
 * for a short delay before rendering.
 *
 */
function LoadingBar({ height = "2px", delay = 350, }) {
    const { delayPassed } = (0, useDelay_1.default)(delay);
    return delayPassed ? ((0, jsx_runtime_1.jsx)(material_1.LinearProgress, { className: "LoadingBar", sx: {
            height,
            marginTop: `-${height}`,
            "& .MuiLinearProgress-bar": {
                bgcolor: "rgb(30%, 30%, 30%)",
            },
        } })) : null;
}
exports.default = LoadingBar;
